import { forwardRef, useState } from 'react';

import { styled } from '@spazious/dollhouse-theme';
import { Flex, FlexElement, FlexProps, Typography } from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';
import { buildId, shortSha, version } from '@spazious/vite-metadata';

import { InfoDialog } from '../InfoDialog/index.js';

export type VersionBannerElement = FlexElement;

export interface VersionBannerProps extends FlexProps {}

export const VersionBanner = styled(
  forwardRef<VersionBannerElement, VersionBannerProps>((props) => {
    const [infoDialogOpen, setInfoDialogOpen] = useState(false);

    const handleDialogOpen = useEventCallback(() => {
      setInfoDialogOpen(true);
    });

    const handleDialogClose = useEventCallback(() => {
      setInfoDialogOpen(false);
    });

    return (
      <Flex column {...props}>
        <Typography role="button" size="small" variant="label" onClick={handleDialogOpen}>
          {[`v${[version, shortSha].filter(Boolean).join('#')}`, `Build: ${buildId}`].join(' ')}
        </Typography>
        <InfoDialog open={infoDialogOpen} onClose={handleDialogClose} />
      </Flex>
    );
  })
).withConfig({
  displayName: 'VersionBanner',
})`
  user-select: none;
  cursor: default;
`;
